module.exports = __webpack_public_path__ + "img/panel-cleaning-icon.87aa2673.svg";